import { prompt, type PromptDefinition } from './models';

export const INSURER_PROMPTS = [
    prompt(
        'Manage risk',
        'What construction and occupancy risks are documented for this building?',
        'Which buildings have construction or occupancy risks needing underwriting review?'
    ),
    prompt(
        'Manage risk',
        "What do this building's inspection reports say about fire protection?",
        'Which buildings have fire-protection findings to prioritise for underwriting?'
    ),
    prompt(
        'Manage risk',
        'Which risk recommendations for this building remain unverified?',
        'Which buildings lack evidence that insurance risk recommendations were completed?'
    ),
    prompt(
        'Manage risk',
        'Find underwriting evidence for this building about…',
        'Find underwriting evidence across my buildings about…',
        'prefill'
    ),
    prompt(
        'Manage risk',
        "What claims or loss events are described in this building's available records?",
        'Compare documented claims and loss events across my buildings.'
    ),
    prompt(
        'Manage risk',
        'What policy dates and coverage details are recorded for this building?',
        'Which buildings have policy renewals or documented coverage gaps to review?'
    ),
    prompt(
        'Keep it running',
        "What evidence shows this building's protective systems are being maintained?",
        'Which buildings lack recent maintenance evidence for protective systems?'
    ),
    prompt(
        'Manage risk',
        'Find policy wording for this building relating to…',
        'Find policy wording across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Manage risk',
        "What changes to this building's use or condition are documented?",
        'Which buildings have documented changes that may need underwriting reassessment?'
    ),
    prompt(
        'Manage risk',
        'What do the records say about flood, water or other hazards at this building?',
        'Compare documented hazard exposure across my buildings.'
    ),
    prompt(
        'Manage risk',
        "Which reports are still needed to assess this building's insurance risk?",
        'Which buildings have incomplete insurance-risk assessment records?'
    ),
    prompt(
        'Manage risk',
        'Trace the loss-event evidence for this building involving…',
        'Compare loss-event evidence across my buildings involving…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
